import 'babel-polyfill';
import '@/assets/style.css';
import '@/assets/design-system.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import Vue from 'vue';
import Notifications from 'vue-notification';
import App from './App.vue';
import vuetify from '@/plugins/vuetify';
import prepareVuelayers from '@/plugins/vuelayers';
import './registerServiceWorker';
import router from './router';
import store from './store';
import NetworkService from '@/services/network';
import CapacitorService from '@/services/capacitor';

Vue.config.productionTip = false;
prepareVuelayers();
Vue.use(Notifications);

// Initialize Capacitor services
async function initCapacitor() {
  // Initialize network monitoring
  await NetworkService.init();

  // Hide splash screen after app is ready (native only)
  await CapacitorService.splashScreen.hide();

  // Configure status bar (native only)
  await CapacitorService.statusBar.setStyle('dark');
  await CapacitorService.statusBar.setBackgroundColor('#000000');
}

// Start Capacitor initialization (don't block app mounting)
initCapacitor().catch((error) => {
  console.error('Error initializing Capacitor:', error);
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
